/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateEnrollmentScheduleDto } from '../../models/update-enrollment-schedule-dto';

export interface EnrollmentScheduleControllerUpdateRepeatV1$Params {
  id: string;
  repeatUpdateType: 'THIS' | 'THIS_AND_FUTURE' | 'ALL';
      body: UpdateEnrollmentScheduleDto
}

export function enrollmentScheduleControllerUpdateRepeatV1(http: HttpClient, rootUrl: string, params: EnrollmentScheduleControllerUpdateRepeatV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, enrollmentScheduleControllerUpdateRepeatV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('repeatUpdateType', params.repeatUpdateType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

enrollmentScheduleControllerUpdateRepeatV1.PATH = '/api/v1/enrollment-schedule/{id}/repeat';
